<template>
  <div>
    <div class="h-13 flex bg-slate-100">
      <div class="sticky left-60 z-10 pl-6 flex bg-slate-100">
        <div
          class="w-60 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400 border-l"
          :class="{ 'rounded-bl': isLast }"
        >
          <BlTextBody2
            :title="subscription.name"
            :text="subscription.name"
            class="truncate text-slate-1000"
          />
        </div>
      </div>
      <div
        class="w-35 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
      >
        <BlTextBody2
          :text="displayDate({ date: subscription.start_date })"
          class="truncate"
        />
      </div>
      <div
        class="w-35 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
      >
        <BlTextBody2
          :text="displayDate({ date: subscription.expiration_date })"
          class="truncate"
        />
      </div>
      <div
        class="w-35 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
      >
        <BlTextBody2 :text="subscription.number_of_seats" />
      </div>
      <div
        class="w-60 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400 gap-1"
      >
        <BlTextBody2 :text="subscription.currency_sym" />
        <BlTextBody2 :text="priceFormats(subscription.amount)" />
      </div>
      <div
        class="w-35 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400"
      >
        <BlChip :chip="subscription.status" dense />
      </div>
      <!-- <div
        class="w-44 pl-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400 justify-end gap-1"
      >
        <router-link
          :to="
            `/super-admin/center/${centerId}/subscription/${subscription.id}`
          "
        >
          <BlInputButton type="outlined" dense label="Manage subscription" />
        </router-link>
      </div> -->
      <div class="sticky right-0 z-10 pr-6 flex bg-slate-100 flex-grow">
        <div
          class="w-56 px-4 flex items-center flex-shrink-0 bg-pure-white border-b border-slate-400 border-r justify-end gap-2 flex-grow"
          :class="{ 'rounded-br': isLast }"
        >
          <BlInputButton
            v-if="subscription.status === 'scheduled'"
            type="outlined-error"
            icon="delete"
            dense
            title="Delete subscription"
            @clicked="deleteOpened = true"
          />
          <router-link
            :to="
              `/super-admin/center/${centerId}/subscription/${subscription.id}`
            "
          >
            <BlInputButton type="outlined" dense label="Manage subscription" />
          </router-link>
          <!-- <div v-if="subscription.status === 'scheduled'" class="relative">
            <BlInputButton
              type="plain"
              dense
              icon="dots-vertical"
              class="hover:bg-hover-state"
              @clicked="menuOpened = !menuOpened"
            />
            <div
              v-if="menuOpened"
              class="absolute z-50 top-0 right-full mr-3 py-2 px-2 flex flex-col gap-1 bg-pure-white rounded border border-slate-400"
            >
              <div
                class="px-4 py-2 min-w-48 rounded hover:bg-hover-state cursor-pointer"
                @click="deleteOpened = true"
              >
                <BlTextBody2
                  class="text-error-400"
                  text="Delete subscription"
                />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <BlBackdrop
      v-if="deleteOpened"
      :title="`Delete subscription`"
      :label="`Delete subscription`"
      type="error"
      :submitLoading="submitLoading"
      @backdrop-close="deleteOpened = false"
      @backdrop-action="onDelete"
    >
      <div class="px-8 flex flex-col">
        <BlTextBody2
          text="You are about to delete the subscription with the following details:"
        />
        <div class="flex items-center gap-2">
          <div class="h-0.5 w-0.5 flex-shrink-0 rounded bg-slate-800"></div>
          <BlTextBody2 text="Subscription Name:" />
          <BlTextBody2 :text="subscription.name" class="font-bold" />
        </div>
        <div class="flex items-center gap-2">
          <div class="h-0.5 w-0.5 flex-shrink-0 rounded bg-slate-800"></div>
          <BlTextBody2 text="Total Amount Due:" />
          <div>
            <BlTextBody2 :text="subscription.currency_sym" class="font-bold" />
            <BlTextBody2
              :text="priceFormats(subscription.amount)"
              class="font-bold"
            />
          </div>
        </div>
        <div class="flex items-center gap-2">
          <div class="h-0.5 w-0.5 flex-shrink-0 rounded bg-slate-800"></div>
          <BlTextBody2 text="Number of Seats:" />
          <BlTextBody2 :text="subscription.number_of_seats" class="font-bold" />
        </div>
        <div class="flex items-center gap-2">
          <div class="h-0.5 w-0.5 flex-shrink-0 rounded bg-slate-800"></div>
          <BlTextBody2 text="Start Date:" />
          <BlTextBody2
            :text="
              displayDate({
                date: subscription.start_date,
                format: 'DD MMMM YYYY'
              })
            "
            class="font-bold"
          />
        </div>
        <div class="flex items-center gap-2">
          <div class="h-0.5 w-0.5 flex-shrink-0 rounded bg-slate-800"></div>
          <BlTextBody2 text="Expiry Date:" />
          <BlTextBody2
            :text="
              displayDate({
                date: subscription.expiration_date,
                format: 'DD MMMM YYYY'
              })
            "
            class="font-bold"
          />
        </div>
        <div class="mt-4">
          <BlTextBody2
            text="Are you sure you want to proceed? This action is irreversible."
          />
        </div>
      </div>
    </BlBackdrop>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { displayDate, displayPrice } from "@/plugins/helper.js";

import EditUserRoleModal from "../../../team/EditUserRoleModal.vue";
import EditUserAccessModal from "../../../team/EditUserAccessModal.vue";
import ResetUserPasswordModal from "../../../team/ResetUserPasswordModal.vue";
import DeactivatedUserModal from "../../../team/DeactivatedUserModal.vue";

import BlTextBody2 from "../../../BlTextBody2.vue";
import BlInputButton from "../../../BlInputButton.vue";
import BlChip from "../../../BlChip.vue";
import BlBubbleCount from "../../../BlBubbleCount.vue";
import BlBackdrop from "../../../BlBackdrop.vue";

export default {
  name: "SubscriptionItem",
  components: {
    EditUserRoleModal,
    EditUserAccessModal,
    ResetUserPasswordModal,
    DeactivatedUserModal,
    BlTextBody2,
    BlInputButton,
    BlChip,
    BlBubbleCount,
    BlBackdrop
  },
  props: {
    subscription: { type: Object, required: true },
    centerId: { type: Number },
    isLast: { type: Boolean, default: false }
  },
  data() {
    return {
      menuOpened: false,
      submitLoading: false,
      deleteOpened: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "center"])
  },
  watch: {
    menuOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandlerMenu);
        }, 10);
      }
    }
  },
  async mounted() {},
  methods: {
    ...mapActions(["deleteSubscription"]),
    displayDate,
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.subscription.currency_settings;
      return this.displayPrice({ settings, price });
    },
    closeHandlerMenu() {
      window.removeEventListener("click", this.closeHandlerMenu);
      this.menuOpened = false;
    },
    //
    async onDelete() {
      const params = {
        center_id: this.center.id,
        id: this.subscription.id
      };

      this.submitLoading = true;
      const { success } = await this.deleteSubscription(params);
      this.submitLoading = false;
      if (!success) return;
      this.deleteOpened = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/center/subscription/Item.vue